import { createContext } from 'react';
import { DEFAULT_SERVICE_CLIENT_CONTEXT } from './constants/defaultContext';

export const ServiceClientContext = createContext(
    DEFAULT_SERVICE_CLIENT_CONTEXT
);
